import Repository from "@/repositories/RepositoryFactory";
import ENUM from "../../enums/APISTATE";
import moment from 'moment';

const GroupCommentRepository = Repository.get("groupComments");
const GroupRepository = Repository.get("groups");

export default {
  namespaced: true,
  state: {
    apiState: ENUM.INIT,
    apiStateDashboard: ENUM.INIT,
    groupComments: [],
    groupComment: {},    
    groupCommentsDashboard: [],
    lookupArgs: null,
    editingGroupComment: null,
    groupCommentMeta: { group: '', date: '' }
  },

  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setApiStateDashboard: (state, apiState) => {
      state.apiStateDashboard = apiState;
    },
    setGroupComments: (state, groupCommentsResponse) => {
      const {data} = groupCommentsResponse;
      state.groupComments = data;
      state.apiState = ENUM.LOADED;
    },
    setGroupCommentsDashboard: (state, respones) => {
      const {data} = respones;
      state.groupCommentsDashboard = data;
      state.apiStateDashboard = ENUM.LOADED;
    },
    setGroupComment: (state, groupCommentResponse) => {
      const {data} = groupCommentResponse;
      state.groupComment = data;
      state.apiState = ENUM.LOADED;
    },
    setLookupArgs: (state, lookupArgs) => {
      state.lookupArgs = lookupArgs;
    },
    setEditingGroupComment: (state, groupCommentResponse) => {
      const {data} = groupCommentResponse;
      state.editingGroupComment = data;
      state.apiState = ENUM.LOADED;
    },
    setGroupCommentMetaGroup: (state, groupResponse) => {
      const {data} = groupResponse;
      state.groupCommentMeta.group = data.title;
    },
    setGroupCommentMetaDate: (state, date) => {
      state.groupCommentMeta.date = moment(date).format("D. MMMM");
    },
    setCleared: (state) => {
      state.apiState = ENUM.LOADED;
      state.apiStateDashboard = ENUM.LOADED;
      state.groupComments= [];
      state.groupComment = {};
      state.groupCommentsDashboard = [];
      state.lookupArgs = null;
      state.editingGroupComment = null;
      state.groupCommentMeta = { group: '', date: '' };
    }
  },

  actions: {
    clear({commit}) {
      commit('setCleared');
    },

    // Load all groupComments for the given group and date-range.
    async loadGroupComments({commit, dispatch}, {fromDate, toDate, forGroup}) {
      dispatch('cancelEditingGroupComment');
      commit('setApiState', ENUM.LOADING);
      try {
        if (forGroup === null) {
          commit('setCleared');
        }
        else {
          commit('setLookupArgs', {fromDate, toDate, forGroup});
          commit('setGroupComments', await GroupCommentRepository.get(fromDate, toDate, forGroup));
        }
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    
    async loadGroupCommentsDashboard({commit, dispatch}, {fromDate, toDate}) {
      dispatch('cancelEditingGroupComment');
      commit('setApiStateDashboard', ENUM.LOADING);
      try {
        commit('setGroupCommentsDashboard', await GroupCommentRepository.getGroupCommentsDashboard(fromDate, toDate));
      }
      catch (error) {
        console.error(error);
        commit('setApiStateDashboard', ENUM.ERROR);
      }
    },

    // Load the groupComment for the given date and group.
    async loadGroupComment({commit}, {forDate, forGroup}) {
      commit('setApiState', ENUM.LOADING);
      try {
        if (forGroup === null) {
          commit('setCleared');
        }
        else {
          commit('setGroupCommentMetaGroup', await GroupRepository.getById(forGroup));
          commit('setGroupCommentMetaDate', forDate);
          commit('setGroupComment', await GroupCommentRepository.getForDayAndGroup(forDate, forGroup));
        }
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },

    async createOrUpdateGroupComment({commit, dispatch, state}, groupCommentModel) {
      commit('setApiState', ENUM.LOADING);
      try {
        await GroupCommentRepository.createOrUpdate(groupCommentModel);
        dispatch('loadGroupComments', state.lookupArgs);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },

    // Open the groupComment sidebar and load the comment for the given date and the group-reference stored in lookupArgs.
    // Do nothing, if no group-reference is set.
    async editGroupComment({commit, state}, forDate) {
      if (state.lookupArgs === null)
        return;

      commit('setEditingGroupComment', {data: {}}); // show modal immediately
      commit('setApiState', ENUM.LOADING);
      try {
        commit('setGroupCommentMetaGroup', await GroupRepository.getById(state.lookupArgs.forGroup));
        commit('setGroupCommentMetaDate', forDate);
        commit('setEditingGroupComment', await GroupCommentRepository.getForDayAndGroup(forDate, state.lookupArgs.forGroup));
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
        commit('setEditingGroupComment', {data: null});
      }
    },

    // Commit the currently edited groupComment
    async commitEditingGroupComment({commit, state, dispatch}, updatedGroupCommentModel) {
      commit('setApiState', ENUM.LOADING);
      try {
        await GroupCommentRepository.createOrUpdate(updatedGroupCommentModel);
        await dispatch('loadGroupComments', state.lookupArgs);
        dispatch('cancelEditingGroupComment');
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },

    // Close the groupComment sidebar
    cancelEditingGroupComment({commit}) {
      commit('setEditingGroupComment', { data: null });
    }
  },

  getters: {
    groupCommentsApiStateDashboard: (state) => state.apiStateDashboard,
    groupCommentsApiState: (state) => state.apiState,
    groupComment: (state) => state.groupComment,
    groupComments: (state) => state.groupComments,
    groupCommentMeta: (state) => state.groupCommentMeta,
    editingGroupComment: (state) => state.editingGroupComment,
    groupCommentsDashboard: (state) => state.groupCommentsDashboard,
  }
};
